import {
  CompanyAttributes,
  DocumentClassAttributes,
  MaterialAttributes,
  MaterialStockAttributes,
  OrderAttributes,
  OrderDetailAttributes,
  OrderDetailMaterialAttributes,
  OrderDetailUnitOfMeasureAttributes,
  OrderExtraStatusAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { ActionRequirementEnum } from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/enums/action-requirement.enum"
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenav,
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  IPaginationResult,
  IPaginationResultFrequencies,
  IRequestResult,
} from "app/common/interfaces";
import { SelectionModel } from "@angular/cdk/collections";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatMenuModule } from "@angular/material/menu";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  andWhere,
  buildQuery,
  Ops,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import {
  debounceTime,
  distinctUntilChanged,
  lastValueFrom,
  Observable,
} from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { getCode } from "app/utils/method";
import { Router } from "@angular/router";
import { environment } from "environments/environment.prod";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { LogModalComponent } from "app/modules/shared/log-modal/log-modal.component";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import {
  ExportFileFormat,
  ExportRange,
} from "app/layout/export-overlay/tasks/core/export-task.enum";
import { CompanyService } from "../../configuration/company/company.service.service";
import { MasterUserInterface } from "../../sales/order-generate/interfaces/master-user.interface";
import { AddOrderDetailComponent } from "../../sales/add-order-detail/add-order-detail.component";
import { OrdersCreationService } from "../../sales/order-generate/order-generate.service";
import { CancelOrderComponent } from "../../sales/cancel-order/cancel-order.component";
import { UpdateOrderService } from "../../sales/update-order/update-order.service";
import {
  IUpdateOrder,
  IUpdateOrderUnified,
  IUserApprovalResponse,
} from "../../sales/update-order/interfaces/update-order.interface";
import { UpdateOrderComponent } from "../../sales/update-order/update-order.component";
import { OrdersListService } from "../../sales/order-list-components/order-list.service";
import { SelectOrderDetailComponent } from "../../sales/select-order-detail/select-order-detail.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { validateOrdersByAction } from "app/utils/document-class-validation";
import { IOrderDetailsUpdate } from "./interfaces/orderDetailsUpdate.interface";
import { MaterialService } from "../../material/material/material.service";
import AlternalUnitMeasurementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity";
import { BatchesDetailComponent } from "app/modules/shared/batches-detail/batches-detail.component";
import { ChangeTripOrderComponent } from "../../sales/change-trip-order/change-trip-order.component";
import { CreditNoteDialogComponent } from "../payment-load-list/credit-note/credit-note.component";
import { LoadsService } from "../../assistant/delivery/loads/loads.service";
import { MatBadgeModule } from "@angular/material/badge";
import { DocumentFlowComponent } from "app/modules/shared/document-flow/document-flow.component";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { DocumentNavigationComponent } from "app/common/components/document-navigation/document-navigation.component";
import { BusinessPartnerDisplayComponent } from 'app/shared/components/business-partner-display/business-partner-display.component';
import { OrderPaymentAService } from "../../reports/historic/order-payment/order-payment.service";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
import { InvoiceService } from 'app/modules/components/sales/invoice-list/Print/pdf-generator.service';
import { InvoicePdfOptions } from 'app/modules/components/sales/invoice-list/Print/invoice-pdf-options.interface';
import { NoteDetailModalComponent } from 'app/modules/shared/note-detail-modal/note-detail-modal.component';
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import { CustomDialogComponent } from "app/shared/components/custom-dialog/custom-dialog.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";


@Component({
  selector: "app-table-load-list",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatTabsModule,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenav,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatBadgeModule,
    MonedaPipe,
    DocumentFlowButtonComponent,
    DecimalFormatPipe,
    DocumentNavigationComponent,
    BusinessPartnerDisplayComponent,
    NoteDetailModalComponent,
    UnitMeasureDisplayComponent

  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
  templateUrl: "./table-load-list.component.html",
  styleUrl: "./table-load-list.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class LoadTableListComponent implements OnInit {
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("orderCreditNote") orderCreditNote!: TemplateRef<any>;
  @ViewChild('noteModal') noteModal!: TemplateRef<any>;
  @Input() summaryData: OrderAttributes[] | null = [];
  @Input() UMPActive: boolean = false;
  @Input() isAllColumns: boolean = true;
  @Input() isAllColumnsMerma: boolean = false;
  @Input() isAllColumnsTransport: boolean = false;
  @Input() isSearch: boolean = false;
  @Input() isFact: boolean = false;
  @Input() canJoin: boolean = false;
  @Input() relatedPayments: any[] = [];
  @Input() batchesDetail: boolean = false;
  @Output() refreshMonitor = new EventEmitter();
  @Input() canEdit: boolean = false;
  @Input() canRelease: boolean = false;

  @Input() totalItems: number = 0;
  @Input() pageSize: number = 50;
  @Input() currentPage: number = 1;

  @Output() pageChanged = new EventEmitter<PageEvent>();

  getCode = getCode;
  projectName = environment.projectName;
  StatusEnum = StatusEnum
  DocumentTypeEnum = DocumentTypeEnum;
  
  displayedColumns: string[] = [
    "det",
    "check",
    "status",
    "statusERP",
    "type",
    "businessPartner",
    // "documentNumberInvoice",
    "documentNumber",
    "class",
    //'date',
    "subTotal",
    //'surcharge', 'discount', 'tax',
    "total",
    "creation",
    "loadDateTime",
    // 'documentStatus',
    "actions",
  ];

  paymentMethodsDisplayedColumns: string[] = [
    // "inner",
    "paymentMethod",
    "bank",
    "operationNumber",
    "overpayment",
    "paying",
  ];
  paymentMethodsDataSource = new MatTableDataSource<OrderPaymentAttributes>([]);

  dataSource = new MatTableDataSource<OrderAttributes>([]);
  totalItemsIn: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageIndex: number = 1;
  sortActive: keyof OrderAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  selection = new SelectionModel<any>(true, []);
  selectedOrder: OrderAttributes | null = null;
  totalPaying: number = 0;
  totalOverPayment: number = 0;
  currency: string;
  //DETAIL
  displayedColumnsDetail: string[] = [
    "material",
    "note",
    "warehouse",
    "soldQuantity",
    "unitPrice",
    "subTotal",
    "totalSurcharges",
    "totalDiscounts",
    "tax",
    "total",
    //"actions",
  ];
  dataSourceDetail = new MatTableDataSource<OrderDetailAttributes>([]);

  companyList: CompanyAttributes[] = [];

  //Filter
  selectedStartDate: Date;
  selectedEndDate: Date;
  dateRange: FormGroup;
  selectedStatusERP: number = 0;
  selectedDocumentClass: string = "0";
  selectedSeller: string = "0";
  selectedWithTravel: string = "0";

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  isGlobalSynchronizeAvailable: boolean = false;

  orderStatusErpList = [
    { id: null, name: "Todos" },
    { id: 0, name: "Pendiente" },
    { id: 4, name: "Error enviando a ERP" },
    { id: 1, name: "Enviado a ERP" },
    { id: 2, name: "Recibido por ERP" },
    { id: 3, name: "Creado en ERP" },
  ];

  isOrderListTrip = environment.isOrderListTrip;
  isErpIntegrated = environment.isErpIntegrated;

  @ViewChild("orderDetailUpdateConfirmationDialog")
  orderDetailUpdateConfirmationDialog!: TemplateRef<any>;

  @ViewChild("confirmDialog") confirmDialog!: TemplateRef<any>;

  interval;
  timeInterval = 60000 * 15;
  showInterval: boolean = false;

  companies: CompanyAttributes[] = [];

  documentType: any = [];
  TripIds: any = [];

  //VARIABLES PARA UNIFICAR
  isNoOrderSelectionJoin: boolean = false;

  //DATOS DE EDIT
  currentUpdatedDetailOrder: IOrderDetailsUpdate;
  materialList: OrderDetailMaterialAttributes[] = [];
  soldUnitOfMeasureList: OrderDetailUnitOfMeasureAttributes[] = [];
  pararellUnitOfMeasureList: OrderDetailUnitOfMeasureAttributes[] = [];

  //release
  OrderStatusERPEnum = OrderStatusERPEnum
  isNoOrderSelectionRelease: boolean = false;

  constructor(
    private readonly ordersListService: OrdersListService,
    private readonly updateOrderService: UpdateOrderService,
    private readonly ordersCreationService: OrdersCreationService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly warehouseService: WarehouseService,
    private readonly documentClassService: DocumentClassService,
    private readonly companyService: CompanyService,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private readonly orderPaymentService: OrderPaymentAService,
    private loadService: LoadsService,
    private invoiceService: InvoiceService,
    private fb: FormBuilder,
    private exportService: ExportService
  ) {
    const today = new Date();
    this.dateRange = this.fb.group({
      start: [today],
      end: [today],
    });
    this.selectedStartDate = today;
    this.selectedEndDate = today;
    // this.selectedStartDate.setHours(0, 0, 0, 0);
    this.selectedEndDate.setHours(23, 59, 59, 999);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["summaryData"] && this.summaryData) {
      this.dataSource.data = this.summaryData ?? [];
      this.displayedColumns = this.isAllColumnsMerma
        ? [
          "det",
          "check",
          "status",
          "statusERP",
          "type",
          "businessPartner",
          "documentNumberInvoice",
          "documentNumber",
          "class",
          "subTotal",
          "total",
          "actions",
        ]
        : this.displayedColumns;

      this.displayedColumns = this.isAllColumnsTransport
        ? [
          "det",
          "check",
          "status",
          "statusERP",
          "type",
          "businessPartner",
          "documentNumber",
          "documentT",
          "class",
          "subTotal",
          "total",
          "creation",
          "loadDateTime",
          "actions",
        ]
        : this.displayedColumns;

      // 3. Obtener clases de documento dinámicamente
      let documentType = this.summaryData?.[0]?.type?.code;
      const originalDocumentType = documentType;

      // Mapeo de tipos especiales
      if (documentType === DocumentTypeEnum.DOCUMENTO_DE_CARGA) {
        documentType = DocumentTypeEnum.PEDIDO; // Enviamos DocumentTypeEnum.PEDIDO cuando recibimos DocumentTypeEnum.DOCUMENTO_DE_CARGA
      }

      this.documentType = originalDocumentType; // Guardamos el valor (DocumentTypeEnum.DOCUMENTO_DE_CARGA)
      this.TripIds = this.summaryData?.[0]?.trip?._id;

      if (documentType) {
        this.fetchDocumentClass(documentType);
      }
    }
  }

  ngOnInit(): void {
    this.getCompanies();
    // this.getCompanies().then(() => {
    //   this.onFilter();
    // });
    // this.fetchDocumentClass();
    // this.getListSeller();
    if (this.summaryData) {
      this.dataSource.data = this.summaryData ?? [];
      this.documentType = this.summaryData?.[0]?.type?.code;
      this.TripIds = this.summaryData?.[0]?.trip?._id;
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    // this.searchControl.valueChanges
    //   .pipe(
    //     debounceTime(500),
    //     distinctUntilChanged()
    //   )
    //   .subscribe((filterValue: string) => {
    //     this.pageIndex = 1;
    //     this.search = filterValue;
    //     this.getList();
    //   });
  }

  public onSearchChange(event) {
    const search = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    this.dataSource.data = this.summaryData.filter((data: any) => {
      return data?.soldTo?.name.toLowerCase().includes(search);
    });
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  openInterval(event) {
    //para el html si se quiere activar o no
    if (!event) {
      this.showInterval = false;
    } else {
      this.showInterval = true;
    }
    this.onFilter();
  }

  onFilter() {
    if (this.showInterval) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.getList();

      this.interval = setInterval(() => {
        this.getList();
      }, this.timeInterval);
    } else {
      this.getList();
    }
  }

  getList() {
    this.synchronizeDates();
    this.isGlobalSynchronizeAvailable = false;
    this.resetSelection();

    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sortDirection === "asc" ? "ASC" : "DESC";

    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: sortField,
      sortDirection: sortDirection,
    };
    let dataFilter = {
      type: DocumentTypeEnum.DOCUMENTO_DE_CARGA, // Documentos de carga
      startDate: new Date(
        new Date(this.selectedStartDate).setHours(0, 0, 0, 0)
      ).toISOString(),
      endDate: new Date(
        new Date(this.selectedEndDate).setHours(23, 59, 59, 999)
      ).toISOString(),
      documentClass: this.selectedDocumentClass,
      seller: this.selectedSeller.toString(),
      withTravel: this.selectedWithTravel,
      statusERP: this.selectedStatusERP,
    };

    this.ordersListService.findAllWithCount(options, dataFilter).subscribe({
      next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
        this.dataSource.data = res?.data?.data ?? [];
        this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error fetching quotation list", "Cerrar", { duration: 5000 });
      },
    });
  }

  private getSortField(): keyof OrderAttributes {
    const sortFieldMapping: Record<string, keyof OrderAttributes> = {
      status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",
    };
    return sortFieldMapping[this.sortActive] || "creationDateTime";
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    // this.getList()
  }

  // changePage(e: PageEvent) {
  //   this.pageIndex = e.pageIndex + 1;
  //   this.pageSize = e.pageSize;
  //   this.getList();
  // }

  changePage(event: PageEvent) {
    this.pageChanged.emit(event);
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
  }

  isAllSelected() {
    const validRows = this.dataSource.data.filter((row) =>
      this.validateDataToSynchronize(row) || this.validateDataToRelease(row)
    );

    const numSelected = this.selection.selected.length;
    const numValidRows = validRows.length;
    return numSelected == numValidRows && numValidRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
        if (this.validateDataToSynchronize(row) || this.validateDataToRelease(row)) this.selection.select(row);
      });
  }

  resetSelection() {
    this.selection.clear();
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1}`;
  }

  onCheckboxChange(event, element?): void {
    let auxSelected = this.selection.selected;
    this.isGlobalSynchronizeAvailable =
      auxSelected.length > 0 &&
      auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
      0;

    // Nueva validación para unificación
    this.isNoOrderSelectionJoin =
      auxSelected.length < 2 ||
      auxSelected.filter((order) => order.canJoin).length < 2;

    this.isNoOrderSelectionRelease = auxSelected.length < 2 ||
      auxSelected.filter((order) => order.canRelease).length < 2;
  }

  async toggleDetails(order: OrderAttributes): Promise<void> {
    if (this.selectedOrder && this.selectedOrder._id === order._id) {
      this.closeDetails();
      return;
    }

    this.selectedOrder = order;
    this.dataSourceDetail.data = this.selectedOrder.detail || [];

    // Load payments for selected invoice
    this.loadOrderPayments(order?.serial);

    // await this.preparePaymentMethodsData(order);

    // Obtiene compañía para hacer uso de flags

    const companyFound: CompanyAttributes = this.companies.find(
      (c) => c.id == this.selectedOrder.company?.id
    );
    if (companyFound) this.selectedOrder.company = companyFound;
    this.currency = companyFound?.currencyBase?.code ?? "";

    // Obtiene almacenes y clase de documento
    const orderStatusId = this.selectedOrder.statusId;
    if (orderStatusId != StatusEnum.INACTIVE && orderStatusId != StatusEnum.ORDER_APPROVED && orderStatusId != StatusEnum.ORDER_REJECTED) {
      await this.getDocumentClass(this.selectedOrder);

      if (
        this.selectedOrder.class["showCurrentStockForMaterials"] == true &&
        !this.selectedOrder["warehousesToUpdate"]
      ) {
        const salesOffice: Partial<SalesOfficeAttributes> = await lastValueFrom(
          this.salesOfficeService.findOne(
            this.selectedOrder.salesOffice._id.toString()
          )
        ).then((res) => res.data);
        if (salesOffice && salesOffice.warehouses) {
          let filter = {
            officeWarehouse: salesOffice.warehouses.map((ware) => ware._id),
            company: [environment.companyId],
          };
          this.selectedOrder["warehousesToUpdate"] = await lastValueFrom(
            this.warehouseService.filterComboBox(filter)
          ).then((res) => res.data);
          this.getStock(
            this.selectedOrder,
            this.selectedOrder["warehousesToUpdate"]
          );
        }
      }
    }
  }

  closeDetails(): void {
    this.selectedOrder = null;
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if (date) {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, "0");
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const seconds = d.getSeconds().toString().padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }
      return `${day}-${month}-${year}`;
    }
    return "--:--:--";
  }

  formatHour(date: string): string {
    if (date) {
      const d = new Date(date);
      const hours = d.getHours().toString().padStart(2, "0");
      const minutes = d.getMinutes().toString().padStart(2, "0");
      const seconds = d.getSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
    return "--:--:--";
  }

  onCompanySelectionChange(companyid: string): void {
    /*if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }*/
  }

  clearFilters(): void {
    /*this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();*/
    const today = new Date();
    this.dateRange.reset({ start: today, end: today });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.selectedStatusERP = 0;
    this.selectedDocumentClass = "0";
    this.selectedSeller = "0";
  }

  synchronizeDates(): void {
    this.selectedStartDate = this.dateRange.get("start")?.value;
    this.selectedEndDate = this.dateRange.get("end")?.value;
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  async getCompanies(): Promise<void> {
    this.companies = [];
    await lastValueFrom(this.companyService.fetchCompanyByEnvIds())
      .then((res) => {
        this.companies = res.data;
      })
      .catch((err) => {
        this.snackBar.open(err.error.message, "Cerrar", { duration: 3000 });
      });
  }

  private fetchDocumentClass(documentType: string): void {
    let dataToFilter = {
      type: documentType,
    };
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
        this.validateRequirements();
      });
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener vendedores.", "Cerrar", { duration: 5000 });
      },
    });
  }

  synchronizeOrders(order: OrderAttributes) {
    let dataToSendPost = {
      TripIds: [],
      orderIds: [],
      method: "POST",
      documentsType: [],
    };

    let dataToSendPut = {
      TripIds: [],
      orderIds: [],
      method: "PUT",
      documentsType: [],
    };

    // Datos para el servicio (no-DocumentTypeEnum.DOCUMENTO_DE_CARGA)
    let dataToSendOtherPost = {
      TripIds: [],
      orderIds: [],
      method: "POST",
      documentsType: [this.documentType],
    };

    let dataToSendOtherPut = {
      TripIds: [],
      orderIds: [],
      method: "PUT",
      documentsType: [this.documentType],
    };

    const isDT003 = (item: OrderAttributes) => {
      return item.type.code === DocumentTypeEnum.DOCUMENTO_DE_CARGA;
    };
    if (order) {
      // Caso 1: Orden individual
      if (isDT003(order)) {
        // Servicio  para DocumentTypeEnum.DOCUMENTO_DE_CARGA
        if (order.externalKeys?.code) {
          dataToSendPut.orderIds.push(order._id.toString());
        } else {
          dataToSendPost.orderIds.push(order._id.toString());
        }
      } else {
        // Servicio OTRO para no-DocumentTypeEnum.DOCUMENTO_DE_CARGA
        if (order.externalKeys?.code) {
          dataToSendOtherPut.orderIds.push(order._id.toString());
        } else {
          dataToSendOtherPost.orderIds.push(order._id.toString());
        }
      }
    } else {
      if (this.selection.selected.length > 0) {
        // Caso 2: Selección múltiple
        this.selection.selected.forEach((o) => {
          if (isDT003(o)) {
            // Servicio  para DocumentTypeEnum.DOCUMENTO_DE_CARGA
            if (o.externalKeys?.code) {
              dataToSendPut.orderIds.push(o._id.toString());
            } else {
              dataToSendPost.orderIds.push(o._id.toString());
            }
          } else {
            // Servicio OTRO para no-DocumentTypeEnum.DOCUMENTO_DE_CARGA
            if (o.externalKeys?.code) {
              dataToSendOtherPut.TripIds.push(o.trip._id.toString());
            } else {
              dataToSendOtherPost.TripIds.push(o.trip._id.toString());
            }
          }
        });
      } else {
        const tripToSend = this.dataSource.data.find((o) => !isDT003(o));
        if (tripToSend) {
          dataToSendOtherPost.TripIds.push(this.TripIds);
        }
      }
    }

    const requests = [];

    // Servicio  (DocumentTypeEnum.DOCUMENTO_DE_CARGA)
    if (dataToSendPost.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPost).toPromise()
      );
    }
    if (dataToSendPut.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPut).toPromise()
      );
    }

    // Servicio OTRO (no-DocumentTypeEnum.DOCUMENTO_DE_CARGA)
    if (dataToSendOtherPost.TripIds.length > 0) {
      requests.push(
        this.ordersListService
          .synchronizeOrdersOther(dataToSendOtherPost)
          .toPromise()
      );
    }
    if (dataToSendOtherPut.TripIds.length > 0) {
      requests.push(
        this.ordersListService
          .synchronizeOrdersOther(dataToSendOtherPut)
          .toPromise()
      );
    }

    if (requests.length === 0) {
      this.snackBar.open("No se encontraron registros pendientes de sincornizar con ERP.", "Cerrar", { duration: 5000 });
    }

    Promise.all(requests)
      .then(() => {
        this.snackBar.open("Registro sincronizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.refreshMonitor.emit();
        // this.getList();
      })
      .catch((err) => {
        this.snackBar.open(err.error.message || "Error al sincronizar con el ERP.", "Cerrar", { duration: 5000 });
      });
  }

  getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
    const status = list.find((i) => i.type == type);
    return status?.description || "-";
  }

  generateOrder(element) {
    let object = {
      quoteId: element._id,
    };
    this.router.navigate(["master", "sales", "order-generate"], {
      queryParams: object,
    });
  }

  // onUpdateOrder(order: OrderAttributes): void {
  //   const dialogRef = this.dialog.open(UpdateOrderComponent, {
  //     panelClass: "form-modal",
  //     data: order,
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result && result.data) {
  //       const dataTemp = this.dataSource.data.slice();
  //       dataTemp.forEach((order) => {
  //         if (String(order._id) == String(result.data._id)) {
  //           order.address = result.data.address;
  //           order.expeditionCondition = result.data.expeditionCondition;
  //           order.note = result.data.note;
  //           order.statusERP = result.data.statusERP;
  //           order.statusId = result.data.statusId;
  //         }
  //       });
  //       this.dataSource.data = dataTemp;
  //       this.cdr.detectChanges();
  //     }
  //   });
  // }

  onUpdateOrder(order: OrderAttributes): void {
    const data =
      this.selection.selected?.length > 0
        ? this.selection.selected // Enviar arreglo
        : order;

    const dialogRef = this.dialog.open(ChangeTripOrderComponent, {
      panelClass: "form-modal",
      data: data,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.address = result.data.address;
            order.expeditionCondition = result.data.expeditionCondition;
            order.note = result.data.note;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        this.cdr.detectChanges();
      }
      if (result) {
        this.refreshMonitor.emit();
      }
    });
  }

  onUpdateLoadDocument(order: OrderAttributes): void {
    const dialogRef = this.dialog.open(ChangeTripOrderComponent, {
      panelClass: "form-modal",
      data: order,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.refreshMonitor.emit();
    });
  }

  private initializeUpdateDelivery(
    item: OrderDetailAttributes
  ): IOrderDetailsUpdate {
    return {
      materialId: item.material._id.toString(),
      baseUnitOfMeasureId: item.soldUnitOfMeasure._id.toString(),
      pararellUnitOfMeasureId: item.pararellUnitOfMeasure._id.toString(),
      soldQuantity: this.round(item.soldQuantity),
      unitPrice: item.unitPrice,
    };
  }

  public validateInput(event: any) {
    let value = event.target.value;

    let numericValue = parseFloat(value);

    numericValue = parseFloat(numericValue.toFixed(3)) ?? 0;

    event.target.value = numericValue;
    this.currentUpdatedDetailOrder.soldQuantity = numericValue;
  }

  round(valor: number): number {
    return parseFloat(valor.toFixed(3)) ?? 0;
  }

  // Edit Modal

  onOpenModalEditOrderDetail(orderMaterial: OrderDetailAttributes): void {
    this.materialList = [orderMaterial.material];
    this.soldUnitOfMeasureList = [orderMaterial.soldUnitOfMeasure];
    this.pararellUnitOfMeasureList = [orderMaterial.pararellUnitOfMeasure];
    this.currentUpdatedDetailOrder =
      this.initializeUpdateDelivery(orderMaterial);
    const dialogRef = this.dialog.open(this.editModal, {
      panelClass: "form-modal",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      result && this.fetchupdateOrderLoad();
    });
  }

  private fetchupdateOrderLoad() { }
  onCancelOrder(
    order: OrderAttributes,
    orderDetail?: OrderDetailAttributes
  ): void {
    const dialogRef = this.dialog.open(CancelOrderComponent, {
      panelClass: "form-modal",
      data: {
        type: orderDetail ? "DETAIL" : "ORDER",
        order: order,
        orderDetail: orderDetail,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          const detailTemp: OrderDetailAttributes[] = result.data.detail.map(
            (d) => {
              const detailFoundInLocal = this.selectedOrder.detail.find(
                (od) => od.position == d.position
              );
              d["stock"] = detailFoundInLocal
                ? detailFoundInLocal["stock"]
                : [];
              d["stockToValidate"] = detailFoundInLocal
                ? detailFoundInLocal["stockToValidate"]
                : undefined;
              return d;
            }
          );
          this.selectedOrder.detail = detailTemp;
          this.dataSourceDetail.data = this.selectedOrder.detail;
        }
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.reasonForRejection = result.data.reasonForRejection;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        this.cdr.detectChanges();
      }
    });
  }

  onAddOrderDetail(order: OrderAttributes): void {
    const dialogRef = this.dialog.open(AddOrderDetailComponent, {
      panelClass: "form-modal",
      data: {
        order,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.statusERP = result.data.statusERP;
          }
        });
        this.dataSource.data = dataTemp;
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          this.selectedOrder.detail = result.data.detail || [];
          this.dataSourceDetail.data = this.selectedOrder.detail;
          this.getStock(
            this.selectedOrder,
            this.selectedOrder["warehousesToUpdate"]
          );
        }
        this.cdr.detectChanges();
      }
    });
  }

  onChangeWarehouseInOrderDetail(orderDetail: OrderDetailAttributes): void {
    orderDetail["stockToValidate"] = 0;
    if (orderDetail["stock"])
      orderDetail["stockToValidate"] = this.roundToX(
        orderDetail["stock"].find(
          (s: MaterialStockAttributes) =>
            String(s.warehouseId) == String(orderDetail.warehouse._id) &&
            String(s.unitOfMeasureId) ==
            String(orderDetail.soldUnitOfMeasure._id)
        )?.availableStock ?? 0,
        3
      );
    this.cdr.detectChanges();
  }

  onChangeSubTotalInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.soldQuantity < 0) {
      orderDetail.soldQuantity = 0;
      this.snackBar.open("La cantidad no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }

    orderDetail.subTotal = orderDetail.unitPrice * orderDetail.soldQuantity;

    // Calcula descuentos
    orderDetail.totalDiscounts = 0;
    if (orderDetail.discounts && orderDetail.discounts.length > 0) {
      orderDetail.totalDiscounts = orderDetail.discounts.reduce(
        (acc, discount) => {
          switch (discount.type) {
            case "PERCENTAGE":
              return acc + (orderDetail.subTotal * discount.discount) / 100;
            case "AMOUNT":
              return acc + discount.discount;
            default:
              return acc;
          }
        },
        0
      );
    }

    orderDetail.subTotalBeforeTaxes =
      orderDetail.subTotal -
      orderDetail.totalDiscounts +
      orderDetail.totalSurcharges;

    // Calcula impuestos
    orderDetail.totalTaxes = 0;
    if (orderDetail.taxes && orderDetail.taxes.length > 0) {
      orderDetail.totalTaxes = orderDetail.taxes.reduce(
        (acc, tax) =>
          acc + (orderDetail.subTotalBeforeTaxes * tax.percentage) / 100,
        0
      );
    }

    orderDetail.total =
      orderDetail.subTotalBeforeTaxes + orderDetail.totalTaxes;
    this.calculateOrderTotals(order);
  }

  calculateOrderTotals(order: OrderAttributes): void {
    order.subTotal = 0;
    order.totalDiscounts = 0;
    order.totalSurcharges = 0;
    order.subTotalBeforeTaxes = 0;
    order.totalTaxes = 0;
    order.total = 0;

    order.detail.forEach((od) => {
      if (od.statusId == StatusEnum.ACTIVE) {
        order.subTotal += od.subTotal;
        order.totalDiscounts += od.totalDiscounts;
        order.totalSurcharges += od.totalSurcharges;
        order.subTotalBeforeTaxes += od.subTotalBeforeTaxes;
        order.totalTaxes += od.totalTaxes;
        order.total += od.total;
      }
    });
    this.cdr.detectChanges();
  }

  onChangeQuantityInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (
      order.class["makesStockValidation"] &&
      orderDetail["stockToValidate"] &&
      orderDetail.soldQuantity > orderDetail["stockToValidate"]
    ) {
      orderDetail.soldQuantity = orderDetail["stockToValidate"];
      this.snackBar.open(
        "La cantidad no debe ser mayor al disponible.",
        "Cerrar",
        { duration: 3000 }
      );
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  onChangePriceInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.unitPrice < 0) {
      orderDetail.unitPrice = 0;
      this.snackBar.open("El precio no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  openOrderDetailUpdateConfirmation(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    if (orderDetail["thereIsChanges"])
      this.dialog
        .open(this.orderDetailUpdateConfirmationDialog, {
          data: null,
          panelClass: "form-modal",
          disableClose: true,
        })
        .afterClosed()
        .subscribe((result) => {
          if (result) this.onSaveOrderDetailUpdate(order, orderDetail);
        });
    else orderDetail["isEditMode"] = false;
    this.cdr.detectChanges();
  }

  onSaveOrderDetailUpdate(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    const dataToUpdate: IUpdateOrder = {
      detail: [
        {
          position: orderDetail.position,
          warehouseId: orderDetail.warehouse
            ? String(orderDetail.warehouse._id)
            : null,
          soldQuantity: orderDetail.soldQuantity,
          unitPrice: orderDetail.unitPrice,
        },
      ],
    };

    this.updateOrderService
      .updateOrder(String(order._id), dataToUpdate)
      .subscribe({
        next: (result) => {
          this.snackBar.open("Detalle actualizado con éxito.", "Cerrar", {
            duration: 3000,
          });
          orderDetail["isEditMode"] = false;
          orderDetail["thereIsChanges"] = false;
          if (result && result.data) {
            const dataTemp = this.dataSource.data.slice();
            if (
              this.selectedOrder &&
              String(this.selectedOrder._id) == String(order._id)
            ) {
              const detailTemp: OrderDetailAttributes[] =
                result.data.detail.map((d) => {
                  const detailFoundInLocal = this.selectedOrder.detail.find(
                    (od) => od.position == d.position
                  );
                  d["stock"] = detailFoundInLocal
                    ? detailFoundInLocal["stock"]
                    : [];
                  d["stockToValidate"] = detailFoundInLocal
                    ? detailFoundInLocal["stockToValidate"]
                    : undefined;
                  return d;
                });
              this.selectedOrder.detail = detailTemp;
              this.dataSourceDetail.data = this.selectedOrder.detail;
            }
            dataTemp.forEach((order) => {
              if (String(order._id) == String(result.data._id)) {
                order.subTotal = result.data.subTotal;
                order.totalDiscounts = result.data.totalDiscounts;
                order.totalSurcharges = result.data.totalSurcharges;
                order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
                order.totalTaxes = result.data.totalTaxes;
                order.total = result.data.total;
                order.detail = result.data.detail;
                order.statusERP = result.data.statusERP;
              }
            });
            this.dataSource.data = dataTemp;
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el detalle.",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  async getStock(order: OrderAttributes, warehouses: WarehouseAttributes[]) {
    let dataToSend = {
      materialsIds: order.detail
        .filter((od) => od.statusId == StatusEnum.ACTIVE)
        .map((d) => String(d.material._id)),
      unitMeasureIds: [],
      warehouseIds: warehouses.map((w) => String(w._id)),
    };
    const stock: MaterialStockAttributes[] = await lastValueFrom(
      this.ordersCreationService.fetchStock(dataToSend)
    ).then((res) => res.data[0].data);

    const dateToValidate = new Date();
    dateToValidate.setMonth(
      dateToValidate.getMonth() +
      (order.company["totalMonthsToGroupStockInRouting"] ?? 0)
    );
    order.detail.forEach((od) => {
      od["stock"] = stock.filter(
        (s) => String(s.materialId) == String(od.material._id)
      );
      od["stockToValidate"] = this.roundToX(
        (order.company["groupStockByDateInRouting"] == true
          ? od["stock"]
            .filter(
              (s: MaterialStockAttributes) =>
                String(s.warehouseId) == String(od.warehouse._id) &&
                String(s.unitOfMeasureId) ==
                String(od.soldUnitOfMeasure._id) &&
                s.lotExpirationDate &&
                new Date(s.lotExpirationDate).getTime() >=
                dateToValidate.getTime()
            )
            .reduce((acc, s) => acc + s.availableStock, 0)
          : od["stock"].find(
            (s: MaterialStockAttributes) =>
              String(s.warehouseId) == String(od.warehouse._id) &&
              String(s.unitOfMeasureId) == String(od.soldUnitOfMeasure._id)
          )?.availableStock ?? 0) / od.baseConversionFactor,
        3
      );
    });
    if (
      this.selectedOrder &&
      String(this.selectedOrder._id) == String(order._id)
    )
      this.dataSourceDetail.data = this.selectedOrder.detail || [];
    this.cdr.detectChanges();
  }

  async getDocumentClass(order: OrderAttributes) {
    const documentClass: DocumentClassAttributes = await lastValueFrom(
      this.documentClassService.findOne(String(order.class._id))
    ).then((res) => res.data);
    if (documentClass) order.class = documentClass;
    this.cdr.detectChanges();
  }

  roundToX(value: number, decimals: number) {
    return parseFloat(value.toFixed(decimals));
  }

  openLogModal(element:OrderAttributes) {
    let dataToModal = {
      documentIdentifier: element.serial,
    };
    this.dialog.open(LogModalComponent, {
      panelClass: ".form-modal-interlocutor",
      width: "90%",
      data: dataToModal,
      disableClose: true,
    });
  }

  validateDataToSynchronize(order: OrderAttributes): boolean {
    if (this.documentType === DocumentTypeEnum.DOCUMENTO_DE_CARGA) {
      return (
        !!order &&
        (order.statusERP === OrderStatusERPEnum.ORDER_PENDING ||
          order.statusERP === OrderStatusERPEnum.ORDER_ERROR ||
          order.statusERP === OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE ||
          order.statusERP === OrderStatusERPEnum.ORDER_ERROR_ERP) &&
        (order.statusId === StatusEnum.ACTIVE || order.statusId === StatusEnum.ORDER_IN_PROGRESS) &&
        !!order.trip &&
        (!this.isOrderListTrip || !!order.trip?.externalKeys?.code)
      );
    }
    return validateOrdersByAction([order], this.documentClassesList, "SYNC");
  }

  // validateDataToSynchronize(order: OrderAttributes): boolean {
  //   return validateOrdersByAction([order], this.documentClassesList, "SYNC");
  // }

  validateDataToEdit(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "EDIT");
  }

  validateDataToRelease(order: OrderAttributes): boolean {
    //En el documento al configurar el pedido el action release debe tener marcado el estado creado en ERP
    return validateOrdersByAction([order], this.documentClassesList, ActionRequirementEnum.RELEASE);
  }

  validateDataToCopy(order: OrderAttributes) {
    return order?.statusId == StatusEnum.ACTIVE || order?.statusId == StatusEnum.ORDER_IN_PROGRESS || order?.statusId == StatusEnum.ORDER_APPROVED;
  }

  validateDataToDivide(order: OrderAttributes) {
    return (
      (order?.statusId == StatusEnum.ACTIVE || order?.statusId == StatusEnum.ORDER_IN_PROGRESS) &&
      order?.nextTransactions?.length == 0
    );
  }

  validateDataToGenerateOrder(order: OrderAttributes) {
    //Primera regla
    let ruleStatusId: boolean = false;
    if (environment.projectName == "PORTUGAL") {
      ruleStatusId = order?.statusId == StatusEnum.ORDER_APPROVED;
    } else {
      ruleStatusId =
        order?.statusId == StatusEnum.ACTIVE || order?.statusId == StatusEnum.ORDER_IN_PROGRESS || order?.statusId == StatusEnum.ORDER_APPROVED;
    }

    let ruleERPIntegrated: boolean = false;
    ruleERPIntegrated =
      !this.isErpIntegrated || order?.externalKeys?.code != null;

    return ruleStatusId && ruleERPIntegrated;
  }

  validateDataToAppOrRejected(order: OrderAttributes) {
    return (
      (order?.statusERP == OrderStatusERPEnum.ORDER_PENDING ||
        order?.statusERP == OrderStatusERPEnum.ORDER_ERROR ||
        order?.statusERP == OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE ||
        order?.statusERP == OrderStatusERPEnum.ORDER_ERROR_ERP) &&
      (order?.statusId == StatusEnum.ACTIVE || order?.statusId == StatusEnum.ORDER_IN_PROGRESS)
    );
  }

  //aprobar/rechazar
  openModal(element): void {
    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: { element: element, type: "2" }, //'COTIZACIÓN'
      disableClose: true,
    });
     dialogRef
       .afterClosed()
       .subscribe((result: IUserApprovalResponse | "Close" | undefined) => {
         if (result === undefined || result == "Close") {
         } else {
           if (result) {
             let sendOrder: IUpdateOrder = {
               reasonForRejectionId: result.reasonRejectionId ?? null,
               statusId: result.approve
                 ? StatusEnum.ORDER_APPROVED
                 : StatusEnum.INACTIVE,
             };

             this.updateAppReje(element, sendOrder);
           }
         }
       });
  }

  updateAppReje(element, result) {
    this.ordersListService.update(element._id, result).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  cloneOrder(element: OrderAttributes, type: string) {
    //type: 'copy', 'divide'
    const dialogRef = this.dialog.open(SelectOrderDetailComponent, {
      data: { order: element, type: type },
      disableClose: true,
      width: "90%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
      }
    });
  }

  onExportButtonPressed() {
    const id = "sales-quotation-list";
    if (this.exportService.taskIsActive(id)) {
      this.exportService.setVisible(true);
      return;
    }
    this.exportService
      .createForSalesQuotationList(
        this.totalItems,
        this.ordersListService.currentFilter,
        this.ordersListService.currentFilterData,
        ExportRange.CurrentPage,
        ExportFileFormat.Excel
      )
      .start();

    /* const dialogRef = this.dialog.open(ExportDialogComponent);
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.exportService.createForSalesQuotationList(
          this.totalItems,
          this.orderCustomer.currentFilter,
          options.range,
          options.format,
        ).start();
      }
    }); */
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  preparePaymentMethodsData(order: OrderAttributes) {
    if (!order || !this.relatedPayments) {
      this.paymentMethodsDataSource.data = [];
      return;
    }
    const orderPayments = this.relatedPayments.filter((payment) =>
      this.matchPaymentToOrder(payment, order)
    );

    this.paymentMethodsDataSource.data = orderPayments.map((payment) => ({
      ...payment,
      documentSerial: order.serial,
      paymentType: payment.paymentType,
      bank: payment?.bank,
      accountNumber: payment?.accountNumber,
    }));

    this.totalPaying = this.calculateTotalMethod(
      this.paymentMethodsDataSource.data,
      "paying"
    );
    this.totalOverPayment = this.calculateTotalMethod(
      this.paymentMethodsDataSource.data,
      "overpayment"
    );

    this.paymentMethodsDataSource = this.groupPayments(
      this.paymentMethodsDataSource.data
    );
  }

  openCreditNoteDetail(groupedPayment: any): void {
    const detailDataSource = new MatTableDataSource(
      groupedPayment.originalPayments
    );
    this.dialog.open(CreditNoteDialogComponent, {
      width: "800px",
      data: detailDataSource.data,
      autoFocus: false,
    });
  }

  matchPaymentToOrder(payment: any, document: any): boolean {
    const paymentKey = payment.document;
    const documentKey = document.serial;
    return paymentKey === documentKey;
  }

  private groupPayments(payments: any): any {
    const grouped = {};

    payments.forEach((payment) => {
      let key = payment.paymentType?.code || "unknown";
      let groupKey = key;

      const hasBankDetails = payment.bank && payment.account;

      if (hasBankDetails) {
        groupKey = `${key}_${payment.bank.code}_${payment.account.accountNumber}`;
      }

      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          paymentType: payment.paymentType,
          ...(hasBankDetails && {
            bank: payment.bank,
            account: payment.account,
          }),
          totalOverPayment: 0,
          totalPaying: 0,
          originalPayments: [],
        };
      }
      grouped[groupKey].totalOverPayment += payment.overpayment || 0;
      grouped[groupKey].totalPaying += payment.paying || 0;
      grouped[groupKey].originalPayments.push(payment);
    });
    return Object.values(grouped);
  }

  // Función para calcular el total del campo paying
  calculateTotalMethod(
    payments: any,
    method: "paying" | "overpayment"
  ): number {
    if (!payments || !Array.isArray(payments)) return 0;

    return payments.reduce((total, payment) => {
      const amount = Number(payment[method]) || 0;
      return total + amount;
    }, 0);
  }

  openNoteDetail(selectedOrder: OrderAttributes, detail: OrderDetailAttributes) {
    if (!detail.note || detail.note.trim() === '') {
      return;
    }
    const modalData = {
      order: selectedOrder,
      detail: detail,
      note: detail.note,
      material: detail.material
    };
    const dialogRef = this.dialog.open(NoteDetailModalComponent, {
      data: modalData,
      width: '550px',
      maxWidth: '95vw',
      disableClose: true,
      panelClass: 'custom-dialog-container'
    });
  }

  openBatchesDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ) {
    const { type, isEdit } = this.getBatchConfig(order.type.code as DocumentTypeEnum);
    const dialogRef = this.dialog.open(BatchesDetailComponent, {
      width: "90%",
      data: {
        order: order,
        data: orderDetail,
        type: type,
        isEdit: isEdit,
        isChangeCostBatch: false,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined || result == "Close") {
      } else {
      }
    });
  }

  private getBatchConfig(orderTypeCode: DocumentTypeEnum): {
    type: string;
    isEdit: boolean;
  } {
    const deliveryCodes = [DocumentTypeEnum.CAMBIO_DE_PRODUCTO, DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO];
    const normalCodes = [DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO, DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO];
    if (orderTypeCode === DocumentTypeEnum.ENTREGA_SALIDA) {
      return { type: "deliveryBatches", isEdit: false };
    } else if (deliveryCodes.includes(orderTypeCode)) {
      return { type: "deliveryBatches", isEdit: true };
    } else if (normalCodes.includes(orderTypeCode)) {
      return { type: "normal", isEdit: true };
    } else {
      return { type: "normal", isEdit: false };
    }
  }

  iconConfig = {
    DT009: {
      icon: "heroicons_solid:exclamation-circle",
      iconType: "svg",
      tooltip: "En espera de aprobación",
      color: "rgb(236, 199, 58)",
    },
    DT010: {
      icon: "heroicons_solid:exclamation-circle",
      iconType: "svg",
      tooltip: "En espera de aprobación",
      color: "rgb(236, 199, 58)",
    },
    DT013: {
      icon: "local_shipping",
      iconType: "font",
      tooltip: "En espera de recolección",
      color: "rgb(236, 199, 58)",
    },
    DT012: {
      icon: "swap_vert",
      iconType: "font",
      tooltip: "En espera de cambio de producto",
      color: "rgb(236, 199, 58)",
    },
    default: {
      icon: "heroicons_solid:check-circle",
      iconType: "svg",
      tooltip: "Creado",
      color: "rgb(65, 106, 218)",
    },
  };

  getIconConfig(code: string) {
    return this.iconConfig[code] || this.iconConfig.default;
  }

  getSerialsTooltip(element: any): string {
    return element.sourceTransactions
      ?.map((t: any) => `• ${t.serial}`)
      .join("\n");
  }

  //Para unificar documentos de carga

  private async validateRequirements(): Promise<void> {
    const dataTemp = this.dataSource.data.map((order) => {
      const canJoin = validateOrdersByAction(
        [order],
        this.documentClassesList,
        "JOIN"
      );
      const docClass = this.documentClassesList.find(
        (d) => d._id?.toString() === order.class?._id?.toString()
      );
      const canRelease = this.validateDataToRelease(order);
      return {
        ...order,
        canJoin,
        canUnifyConditions: docClass?.canUnifyConditions ?? false,
        canRelease,
      };
    });
    this.dataSource.data = dataTemp;
    this.dataSource._updateChangeSubscription();
  }

  openConfirmSDialog(message: string): void {
    this.dialog
      .open(this.confirmDialog, {
        data: { title: "Advertencia", message: message },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.isNoOrderSelectionJoin = true;
        }
      });
  }

  openMConfirmDialog(): void {
    const ordersToJoinFiltered = this.selection.selected.filter(
      (order) => order.canJoin
    );
    if (ordersToJoinFiltered.length == 0) {
      this.openConfirmSDialog(
        "Los pedidos seleccionados no están permitidos para unificarse."
      );
      return;
    }
    this.dialog
      .open(this.confirmDialog, {
        data: {
          title: "Confirmar",
          innerHTML: `
            <p>Los siguientes pedidos pueden ser unificados:</p>
            <ul>
              ${ordersToJoinFiltered.map((order) => `<li>${order.serial}</li>`).join("")}
            </ul>
            <p>¿Está seguro que desea unificarlos?</p>
          `,
        },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.validateJoinOrderModal(ordersToJoinFiltered);
        }
      });
  }

  validateJoinOrderModal(ordersToJoinFiltered: OrderAttributes[] | any) {
    if (this.selection.selected.length == 0) {
      return;
    }

    const allCanUnify = ordersToJoinFiltered.every(
      (order) => order.canUnifyConditions
    );
    const uniqueClass = new Set(
      ordersToJoinFiltered.map((order) => order.class?._id || "sin_class")
    );
    const materialMap = new Map<string, Set<number>>();

    ordersToJoinFiltered.forEach((order) => {
      order.detail.forEach((item) => {
        const materialId = item.material?._id || ("sin_item" as any);
        const unitPrice = item.unitPrice;

        if (!materialMap.has(materialId)) {
          materialMap.set(materialId, new Set());
        }
        materialMap.get(materialId)?.add(unitPrice);
      });
    });

    let message = "";
    let hasPriceM = false;

    materialMap.forEach((prices, materialId) => {
      if (prices.size > 1) {
        hasPriceM = true;
      }
    });

    if (!allCanUnify) {
      if (uniqueClass.size > 1 && hasPriceM) {
        message =
          "Las órdenes seleccionadas pertenecen a diferentes clases y tienen variaciones en los precios de los materiales.";
        this.openConfirmSDialog(message);
      } else if (uniqueClass.size > 1) {
        message = "Las órdenes seleccionadas pertenecen a diferentes clases.";
        this.openConfirmSDialog(message);
      } else if (hasPriceM) {
        message =
          "Las órdenes seleccionadas tienen variaciones en los precios de los materiales.";
        this.openConfirmSDialog(message);
      }
    }
    this.joinOrders(ordersToJoinFiltered);
  }

  joinOrders(ordersToJoinFiltered: OrderAttributes[]): void {
    let send: IUpdateOrderUnified = {
      orderIds: ordersToJoinFiltered.map((order) => String(order._id)),
    };

    this.loadService.joinOrder(send).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        if (this.selection.selected.length > 0) this.selection.clear();
        this.changeSort({ active: "serial", direction: "asc" }); //volver a llamar servicio
        this.refreshMonitor.emit();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  isThereOrderSourceTransaction(element: any): boolean {
    return (
      element.type.code == DocumentTypeEnum.DOCUMENTO_DE_CARGA &&
      Array.isArray(element?.sourceTransactions) &&
      element.sourceTransactions.some((t) => t?.type?.code === DocumentTypeEnum.PEDIDO)
    );
  }

  goToOrder(element: OrderAttributes) {
    if (element?.serial && Array.isArray(element?.sourceTransactions)) {
      const orderIds = element.sourceTransactions
        .filter((t) => t?.type?.code === DocumentTypeEnum.PEDIDO)
        .map((t) => t.serial)
        .toString();

      if (orderIds.length > 0) {
        const queryParams = { orderIds: orderIds };
        const urlTree = this.router.createUrlTree(
          ["master", "sales", "orders-list"],
          { queryParams }
        );
        const absoluteUrl =
          window.location.origin + this.router.serializeUrl(urlTree);
        window.open(absoluteUrl, "_blank");
      }
    }
  }

  disunifyOrderModal(order?: OrderAttributes): void {
    if (!order || !order._id) {
      this.snackBar.open("Documento no válido para desunificar.", "Cerrar", {
        duration: 3000,
      });
      return;
    }

    // Validación específica del operationType
    if (order.operationType !== 4) {
      this.snackBar.open(
        "Solo se pueden desunificar documentos unificados.",
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    this.dialog
      .open(this.confirmDialog, {
        data: {
          title: "Desunificar documento",
          message: "¿Está seguro que desea separar este documento?",
        },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe(async (result) => {
        if (result == true) {
          try {
            // Enviamos solo el serial del documento
            await lastValueFrom(
              this.updateOrderService.desunifyOrder({
                serial: order._id.toString(),
              })
            );
            this.snackBar.open("Desunificación exitosa", "Cerrar", {
              duration: 3000,
            });
            if (this.selection.selected.length > 0) this.selection.clear();
            this.changeSort({ active: "creationDateTime", direction: "asc" });
            this.refreshMonitor.emit();
          } catch (err) {
            this.snackBar.open(
              err.error?.message || "Error en la desunificación",
              "Cerrar",
              { duration: 3000 }
            );
          }
        }
      });
  }

  private loadOrderPayments(serialInvoice: string): void {
    if (!serialInvoice) {
      this.paymentMethodsDataSource.data = [];
      return;
    }

    this.orderPaymentService
      .findPaymentsByInvoiceSerial(serialInvoice)
      .subscribe({
        next: (response) => {
          this.paymentMethodsDataSource.data = response?.data?.[0]?.data || [];

          this.totalPaying = this.calculateTotalMethod(
            this.paymentMethodsDataSource.data,
            "paying"
          );
          this.totalOverPayment = this.calculateTotalMethod(
            this.paymentMethodsDataSource.data,
            "overpayment"
          );
          this.paymentMethodsDataSource.data = this.groupPayments(
            this.paymentMethodsDataSource.data
          );
        },
        error: (error) => {
          this.snackBar.open(error.error.message || "Error loading payments.", "Cerrar", { duration: 5000 });
          this.paymentMethodsDataSource.data = [];
        },
      });
  }

  reprintInvoice(element: OrderAttributes): void {
    if (!element._id) {
      this.snackBar.open('No se encontró el ID de la factura', 'Cerrar', { duration: 3000 });
      return;
    }
    const invoiceId = element._id.toString();
    const options: InvoicePdfOptions = {
      format: 'letter',
      landscape: false,
      scale: 1,
      printBackground: true,
      marginTop: '10mm',
      marginBottom: '10mm'
    };
    this.invoiceService.downloadAndSaveInvoice(invoiceId, options).subscribe({
      next: () => {
        this.snackBar.open('Factura descargada correctamente', 'Cerrar', { duration: 3000 });
      },
      error: (error) => {
        this.snackBar.open(error.message || 'Error al imprimir la factura', 'Cerrar', { duration: 5000 });
      }
    });
  }
  canReprintInvoice(element: OrderAttributes): boolean {
    return this.invoiceService.canReprintInvoice(element);;
  }

  openConfirmDialog(message: string) {
    return this.dialog.open(CustomDialogComponent, {
      data: {
        title: "Advertencia",
        message: message,
        yes: 'Aceptar'
      },
      panelClass: "delete-modal",
      disableClose: true,
    }).afterClosed();
  }

  openReleaseOrders(order?: OrderAttributes) {
    const ordersToReleaseFiltered = this.selection.selected.filter(o => o.canRelease);

    if (!order && ordersToReleaseFiltered.length === 0) {
      this.openConfirmDialog("Los pedidos seleccionados no están permitidos para liberar.").subscribe();
      return;
    }

    this.dialog.open(this.confirmDialog,
      {
        data: {
          title: "Confirmar",
          message: "¿Está seguro que desea liberar este(os) pedido(s)?",
          innerHTML: `
            <div class="text-sm text-red-600">
              Esta acción es irreversible una vez que se haya(n) liberado el(los) pedido(s).
            </div>
          `,
        },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe(async (result) => {
        if (result == true) {
          try {
            await lastValueFrom(
              this.ordersListService.releaseOrders({
                orderSerials: order ? [order.serial] : ordersToReleaseFiltered.map(order => order.serial),
              })
            );
            this.snackBar.open("Liberación exitosa", "Cerrar", { duration: 3000, });
            if (this.selection.selected.length > 0) this.selection.clear();
            this.changeSort({ active: "creationDateTime", direction: "asc" });
            this.refreshMonitor.emit();
          } catch (err) {
            this.snackBar.open(err.error?.message || "Error en la Liberación", "Cerrar", { duration: 3000 });
          }
        }
      })
  }
}
